export default __webpack_public_path__ + "static/media/hero.783f7978.jpeg";